import React, { useMemo, useState } from 'react';
import { Badge } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { useQuery } from '@tanstack/react-query';
import { adminApi, investorApi } from '@/api';
import { NotificationsModal } from '@/components/common';
import { useSelector } from 'react-redux';

export const NotificationsButton = () => {
  const user = useSelector((state) => state.user);
  const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);
  const { data, refetch, isLoading } = useQuery({
    queryKey: ['getNotifications'],
    queryFn: () =>
      user.userRole === 'admin'
        ? adminApi.getAdminNotifications()
        : user.userRole === 'investor'
          ? investorApi.getInvestorNotifications()
          : null,
    refetchInterval: user.userRole === 'investor' || user.userRole === 'admin' ? 30000 : false,
    refetchOnMount: user.userRole === 'investor' || user.userRole === 'admin',
    refetchOnWindowFocus: user.userRole === 'investor' || user.userRole === 'admin' ? true : null,
    enabled: user.userRole === 'investor' || user.userRole === 'admin'
  });

  const countUnreadNotifications = useMemo(() => {
    if (data && data.data && data.data.length) {
      let unreadCount = 0;
      for (const notification of data.data) {
        if (!notification.isRead) {
          unreadCount++;
        }
      }
      return unreadCount;
    }

    return 0;
  }, [data]);

  return (
    <>
      <BadgeWrapper onClick={() => setIsNotificationModalOpen(true)}>
        <Badge count={countUnreadNotifications}>
          <BellOutlined style={{ fontSize: 24, color: '#212B36' }} />
        </Badge>
      </BadgeWrapper>
      <NotificationsModal
        isOpen={isNotificationModalOpen}
        onClose={() => setIsNotificationModalOpen(false)}
        logs={data ? data.data : null}
        isLoading={isLoading}
        refetch={refetch}
        countUnreadNotifications={countUnreadNotifications}
        isAdmin={user.userRole === 'admin'}
      />
    </>
  );
};

const BadgeWrapper = styled.div`
  .ant-badge:hover {
    cursor: pointer;
    opacity: 0.6;
  }

  .ant-badge-count {
    opacity: 1;
  }
`;
